(() => {
  'use strict';
  function displayCount(cart) {
    return (cart.items || []).reduce((total, item) => {
      const properties = item.properties || {};
      if (properties['For door configuration'] && properties.Component) return total;
      const custom = item.handle === 'custom-garage-door' || Number(item.variant_id || item.id) === 50883177283777;
      if (custom) {
        const quantity = Number(properties._lux_door_quantity || 1);
        return total + (Number.isInteger(quantity) && quantity > 0 ? Math.min(quantity, 999) : 1);
      }
      const quantity = Number(item.quantity);
      return total + (Number.isInteger(quantity) && quantity > 0 ? quantity : 0);
    }, 0);
  }
  window.LuxCartDisplayCount = displayCount;
  let currentCount = Number(document.querySelector('[data-lux-door-count]')?.dataset.luxDoorCount || 0);
  let request = null;
  let revision = 0;
  let scheduled = false;
  function render() {
    document.querySelectorAll('[data-header-cart-count]').forEach(badge => {
      const value = currentCount > 0 ? String(currentCount) : '';
      if (badge.dataset.headerCartCount !== value) badge.dataset.headerCartCount = value;
      badge.dataset.luxDoorCount = String(currentCount);
      badge.classList.toggle('visible', currentCount > 0);
    });
    document.querySelectorAll('[data-atc-banner-cart-button] span').forEach(label => {
      label.textContent = String(currentCount);
    });
  }
  function refresh() {
    if (request) return request;
    const startedAt = revision;
    const route = window.Theme?.routes?.cart_url || '/cart';
    request = fetch(route.replace(/\/$/, '') + '.js', {credentials:'same-origin',headers:{Accept:'application/json'}})
      .then(response => {if (!response.ok) throw new Error('Cart could not be refreshed');return response.json();})
      .then(cart => {if (startedAt === revision && Array.isArray(cart.items)) {currentCount = displayCount(cart);render();}})
      .catch(() => {})
      .finally(() => {request = null;});
    return request;
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => {scheduled = false;render();});
  }
  function bind() {
    document.querySelectorAll('[data-header-cart-count]').forEach(badge => {
      if (badge.dataset.luxCountBound) return;
      badge.dataset.luxCountBound = 'true';
      new MutationObserver(() => {
        const expected = currentCount > 0 ? String(currentCount) : '';
        if (badge.dataset.headerCartCount !== expected) {schedule();refresh();}
      }).observe(badge, {attributes:true,attributeFilter:['data-header-cart-count']});
    });
    render();
  }
  window.addEventListener('cartcount:update', event => {
    if (Array.isArray(event.detail?.items)) {
      revision++;
      currentCount = displayCount(event.detail);
      schedule();
    } else refresh();
  }, true);
  window.addEventListener('pageshow', event => {if (event.persisted) refresh();});
  document.addEventListener('shopify:section:load', bind);
  bind();
})();
